import { render, staticRenderFns } from "./PageInProgress.vue?vue&type=template&id=d0813772&"
import script from "./PageInProgress.vue?vue&type=script&lang=js&"
export * from "./PageInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports